(() => {
  function init(root) {
    if (root.dataset.videoInitialized) return;
    root.dataset.videoInitialized = 'true';
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 749px)');
    const videos = Array.from(root.querySelectorAll('[data-koa-drop-video]'));
    const near = new WeakSet();
    const visible = new WeakSet();
    function reset(video) {
      video.pause();
      video.removeAttribute('data-playing');
      const source = video.querySelector('source');
      if (source && source.hasAttribute('src')) {
        source.removeAttribute('src');
        video.load();
      }
      video.dataset.loadedFor = '';
    }
    function load(video) {
      if (motion.matches || !near.has(video)) return;
      const source = video.querySelector('source');
      const breakpoint = mobile.matches ? 'mobile' : 'desktop';
      const url = mobile.matches ? source.dataset.mobileSrc : source.dataset.desktopSrc;
      if (!url || video.dataset.loadedFor === breakpoint) return;
      video.pause();
      video.removeAttribute('data-playing');
      source.src = url;
      video.dataset.loadedFor = breakpoint;
      video.load();
    }
    function play(video) {
      if (!visible.has(video) || motion.matches) return;
      load(video);
      if (video.readyState >= 2) {
        video.play().then(() => video.setAttribute('data-playing', '')).catch(() => {});
      }
    }
    const nearObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { near.add(entry.target); load(entry.target); }
      else { near.delete(entry.target); entry.target.pause(); entry.target.removeAttribute('data-playing'); }
    }), { rootMargin: '700px 0px' });
    const visibleObserver = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting) { visible.add(entry.target); play(entry.target); }
      else { visible.delete(entry.target); entry.target.pause(); entry.target.removeAttribute('data-playing'); }
    }), { threshold: 0.1 });
    videos.forEach(video => {
      nearObserver.observe(video);
      visibleObserver.observe(video);
      video.addEventListener('canplay', () => play(video));
    });
    mobile.addEventListener('change', () => videos.forEach(video => { reset(video); load(video); play(video); }));
    motion.addEventListener('change', () => videos.forEach(video => {
      if (motion.matches) reset(video);
      else { load(video); play(video); }
    }));
  }
  function initAll(container = document) {
    container.querySelectorAll('[data-koa-drops]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
